<template>
  <div>
    <label class="btc donate-crypto-box">
  <div class="coin">
    <div class="coin-face">
      <svg height="10" viewBox="0 0 32 32" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M21.78 15.37c.51-.61.83-1.4.83-2.26 0-2.74-1.6-4.38-4.24-4.38V5.45c0-.12-.1-.22-.22-.22h-1.27c-.11 0-.2.1-.2.21v3.3h-1.7V5.44c0-.12-.1-.22-.22-.22H13.5c-.12 0-.2.1-.21.21v3.3H9.67c-.12 0-.21.09-.21.21v1.31c0 .12.1.22.21.22h.21c.94 0 1.7.79 1.7 1.75v7c0 .92-.68 1.67-1.55 1.75a.21.21 0 0 0-.18.16l-.33 1.32c-.01.06 0 .13.04.19.04.05.1.08.17.08h3.55v3.3c0 .1.1.2.2.2h1.28c.12 0 .21-.1.21-.22v-3.28h1.7v3.3c0 .1.1.2.21.2h1.27c.12 0 .22-.1.22-.22v-3.28h.85c2.65 0 4.24-1.64 4.24-4.37 0-1.28-.68-2.39-1.68-3zm-6.8-4.01h2.54c.94 0 1.7.78 1.7 1.75 0 .96-.76 1.75-1.7 1.75h-2.55v-3.5zm3.39 8.75h-3.4v-3.5h3.4c.93 0 1.7.78 1.7 1.75 0 .96-.77 1.75-1.7 1.75z" fill="#FFF"></path></svg>
    </div>
    <div class="coin-face"></div>
    <div class="coin-face"></div>
    <div class="coin-face"></div>
    <div class="coin-face">
      <svg height="10" viewBox="0 0 32 32" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M21.78 15.37c.51-.61.83-1.4.83-2.26 0-2.74-1.6-4.38-4.24-4.38V5.45c0-.12-.1-.22-.22-.22h-1.27c-.11 0-.2.1-.2.21v3.3h-1.7V5.44c0-.12-.1-.22-.22-.22H13.5c-.12 0-.2.1-.21.21v3.3H9.67c-.12 0-.21.09-.21.21v1.31c0 .12.1.22.21.22h.21c.94 0 1.7.79 1.7 1.75v7c0 .92-.68 1.67-1.55 1.75a.21.21 0 0 0-.18.16l-.33 1.32c-.01.06 0 .13.04.19.04.05.1.08.17.08h3.55v3.3c0 .1.1.2.2.2h1.28c.12 0 .21-.1.21-.22v-3.28h1.7v3.3c0 .1.1.2.21.2h1.27c.12 0 .22-.1.22-.22v-3.28h.85c2.65 0 4.24-1.64 4.24-4.37 0-1.28-.68-2.39-1.68-3zm-6.8-4.01h2.54c.94 0 1.7.78 1.7 1.75 0 .96-.76 1.75-1.7 1.75h-2.55v-3.5zm3.39 8.75h-3.4v-3.5h3.4c.93 0 1.7.78 1.7 1.75 0 .96-.77 1.75-1.7 1.75z" fill="#FFF"></path></svg>
    </div>
  </div>
  <input class="coin-address" onclick="this.select()" readonly="readonly" spellcheck="false" type="text" value="bc1qw9rj3axr537hf6j6n64qng48me93fgwxxn6khs" /></label><label class="eth donate-crypto-box">
  <div class="coin">
    <div class="coin-face">
      <svg height="10" viewBox="0 0 32 32" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M10.13 17.76c-.1-.15-.06-.2.09-.12l5.49 3.09c.15.08.4.08.56 0l5.58-3.08c.16-.08.2-.03.1.11L16.2 25.9c-.1.15-.28.15-.38 0l-5.7-8.13zm.04-2.03a.3.3 0 0 1-.13-.42l5.74-9.2c.1-.15.25-.15.34 0l5.77 9.19c.1.14.05.33-.12.41l-5.5 2.78a.73.73 0 0 1-.6 0l-5.5-2.76z" fill="#FFF"></path></svg>
    </div>
    <div class="coin-face"></div>
    <div class="coin-face"></div>
    <div class="coin-face"></div>
    <div class="coin-face">
      <svg height="8" viewBox="0 0 32 32" width="8" xmlns="http://www.w3.org/2000/svg"><path d="M10.13 17.76c-.1-.15-.06-.2.09-.12l5.49 3.09c.15.08.4.08.56 0l5.58-3.08c.16-.08.2-.03.1.11L16.2 25.9c-.1.15-.28.15-.38 0l-5.7-8.13zm.04-2.03a.3.3 0 0 1-.13-.42l5.74-9.2c.1-.15.25-.15.34 0l5.77 9.19c.1.14.05.33-.12.41l-5.5 2.78a.73.73 0 0 1-.6 0l-5.5-2.76z" fill="#fff"></path></svg>
    </div>
  </div>
  <input class="coin-address" onclick="this.select()" readonly="readonly" spellcheck="false" type="text" value="0xA92876e6F197eCe894CC55F124C1cC325F11a3Ab" /></label>
  <div v-if="showall">
    <label class="donate-crypto-box">  
    <div class="">
      <div class="">
        <img width="50px" src="dogecoinicon.png" />
      </div>
    </div>
    <input class="coin-address" onclick="this.select()" readonly="readonly" spellcheck="false" type="text" value="DCV3DjtFxQ8DAXE6DvkRtqLANhLhwbjBnF" /></label><label class="donate-crypto-box">
      <div class="">
      <div class="">
        <img width="50px" src="shibaicon.jpg" />
      </div>
    </div>
    <input class="coin-address" onclick="this.select()" readonly="readonly" spellcheck="false" type="text" value="0xA92876e6F197eCe894CC55F124C1cC325F11a3Ab" /></label>
    <div @click="showall = false">Hide</div>
  </div>
  <div v-else>
    <div @click="showall = true">Show Dogecoin and Shib Inu</div>
  </div>
  </div>
</template>

<style scoped>
.donate-crypto-box {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 1em;
  box-sizing: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: text;
}

.coin {
  display: inline-block;
  position: relative;
  min-width: 3em;
  min-height: 3em;
  -webkit-animation: spin 3s cubic-bezier(0.3, 2, 0.4, 0.8) infinite both;
  animation: spin 3s cubic-bezier(0.3, 2, 0.4, 0.8) infinite both;
  transform-style: preserve-3d;
  vertical-align: middle;
}
@-webkit-keyframes spin {
  0%,
  10% {
    transform: rotate(-10deg) perspective(400px);
  }
  90%,
  100% {
    transform: rotate(-10deg) perspective(400px) rotateY(180deg);
  }
}
@keyframes spin {
  0%,
  10% {
    transform: rotate(-10deg) perspective(400px);
  }
  90%,
  100% {
    transform: rotate(-10deg) perspective(400px) rotateY(180deg);
  }
}

.coin-face {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
}
.coin-face:nth-child(1) {
  transform: translateZ(-0.2em) rotateY(-180deg);
}
.coin-face:nth-child(2) {
  transform: translateZ(-0.1em);
}
.coin-face:nth-child(4) {
  transform: translateZ(0.1em);
}
.coin-face:nth-child(5) {
  transform: translateZ(0.2em);
}
.coin-face svg {
  width: 100%;
  height: 100%;
}

.coin-address {
  flex: 1;
  font: 0.7em/2.5 Monaco, monospace;
  text-align: center;
  margin-left: 1em;
  border-width: 0 0 2px;
  border-color: rgba(0, 0, 0, 0.1);
  transition: border-color 0.3s;
  cursor: text;
}
.coin-address:hover {
  transition-duration: 0.1s;
}

.btc {
  max-width: 21em;
}
.btc .coin-face {
  background: shade(#ff9900, 35%);
}
.btc .coin-face:nth-child(1),
.btc .coin-face:nth-child(5) {
  background: #ff9900;
}
.btc .coin-address:hover,
.btc .coin-address:focus {
  border-color: #ff9900;
}

.eth {
  max-width: 23em;
}
.eth .coin-face {
  background: shade(#6f7cba, 35%);
}
.eth .coin-face:nth-child(1),
.eth .coin-face:nth-child(5) {
  background: #6f7cba;
}
.eth .coin-address:hover,
.eth .coin-address:focus {
  border-color: #6f7cba;
}

.ltc {
  max-width: 21em;
}
.ltc .coin-face {
  background: shade(#b5b5b5, 35%);
}
.ltc .coin-face:nth-child(1),
.ltc .coin-face:nth-child(5) {
  background: #b5b5b5;
}
.ltc .coin-address:hover,
.ltc .coin-address:focus {
  border-color: #b5b5b5;
}

body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 4vmin;
}

.donate-crypto-box:nth-child(1) .coin {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}

.donate-crypto-box:nth-child(2) .coin {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.donate-crypto-box:nth-child(3) .coin {
  -webkit-animation-delay: 0.6s;
  animation-delay: 0.6s;
}
</style>

<script>
export default {
  name: "CryptoDonate",
  data() {
    return { showall: false };
  },
};
</script>
